import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import useClinic from 'hooks/useClinic';
import { IClinic } from 'interfaces/clinics';
import ReportingApiToggle from './ReportingApiToggle/ReportingApiToggle';
import ApiKeysTable from './ApiKeysTable/ApiKeysTable';
import ApiUsage from './ApiUsage/ApiUsage';

const ReportingApiPage = () => {
  const { data, isLoading, mutate } = useClinic();
  const clinic = data as IClinic | undefined;

  const isEnabled = !!clinic?.isReportingApiEnabled;

  if (isLoading) {
    return (
      <div className="w-full h-[37rem] flex justify-center items-center">
        <LoadingSpinner className="all-child:fill-magenta" />
      </div>
    );
  }

  return (
    <div
      className="py-2.4 pl-3 pr-4 text-14 leading-[2.1rem]"
      data-testid="page-reporting-api"
    >
      <h3 className="text-24 font-bold leading-[3.6rem]">Reporting API</h3>
      <p className="text-dim-grey">
        Pull Online Scheduling Report data into your own tools with an API key.
      </p>
      <ReportingApiToggle isEnabled={isEnabled} onUpdated={mutate} />
      {isEnabled && (
        <>
          <ApiKeysTable />
          <ApiUsage />
        </>
      )}
    </div>
  );
};

export default ReportingApiPage;
